module.exports = __webpack_public_path__ + "fonts/roboto-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/roboto-regular-webfont.woff
// module id = 3456
// module chunks = 0